import React from 'react';

function ReadonlySelect({ field = {}, value = '' }) {
  const { prettyName = '', defaultValue = '', selectOptions = {} } = field;

  return (
    <tr>
      <td>{prettyName}</td>
      <td>{selectOptions[value] || selectOptions[defaultValue]}</td>
    </tr>
  );
}

export { ReadonlySelect };
